import Styleguide from "@toolkit/Framework/Types/Styleguide";

const zIndex: Styleguide["zIndex"] = {
    stickyFooter: 1286,
};

export default zIndex;
